import i18next from 'i18next';
import locI18next from 'loc-i18next';
import HttpApi from 'i18next-http-backend';
import "../css/i18n.css";

let i18n = new class {
  async init(lang, ns, preLoaded = null) {
    let me = this;
    let promise = null;
      
    const onComplete = function(err, t) {
      me.localise = locI18next.init(i18next, {
        optionsAttr: 'data-i18n-options',
        useOptionsAttr: true,
      });

      i18next.services.formatter.add('html', (value, lng, options) => {
        return $(options.interpolationkey).detach().prop('outerHTML');
      });
      me.refresh();
    };

    let cfg = {
      load: 'currentOnly',
      ns: ns,
      lng:lang,
      fallbackLng: 'en',
    };

    if ( preLoaded !== null ) {
      // load from object
      if ( lang == null ) {
        lang = 'en';
      }

      let res = {};
      res[lang] = {};

      Object.entries(preLoaded).forEach(([key,val])=>{
        let keyParts = key.split(":");
        if (keyParts.length == 2) {
          if ( !res[lang][keyParts[0]] ) {
            res[lang][keyParts[0]] = {};
          }
          let subKeys = keyParts[1].split('.');
          let obj = res[lang][keyParts[0]];

          for (let i = 0; i < subKeys.length; i++) {
            if (i < subKeys.length-1 ) {
              if ( !obj[subKeys[i]] ) {
                obj[subKeys[i]] = {};
              }
              obj = obj[subKeys[i]];
            } else {
              obj[subKeys[i]] = val;
            }
          };
        }
      });

      cfg['resources'] = res;
      promise = i18next.init(cfg, onComplete);

    } else {
      // load from server
      cfg['backend'] = {
        loadPath: 'locales/{{lng}}/{{ns}}.json'
      };
      promise = i18next.use(HttpApi).init(cfg, onComplete);
    }

    return promise;
  }
  refresh() {

    $('#g-item-manager').attr('dir', i18next.dir(i18next.resolvedLanguage));

    // remove any previous language related classes
    if ( $('#g-item-manager').data('lang') != null) {
      let prevLng = $('#g-item-manager').data('lang').split('-');
      $('#g-item-manager').removeClass(prevLng[0]);
      if (prevLng.length > 1) {
        $('#g-item-manager').removeClass($('#g-item-manager').data('lang'));
      }
    }

    // add some classes to help with language specific style overrides
    let lng = i18next.resolvedLanguage.split('-');
    $('#g-item-manager').addClass(lng[0]);
    if (lng.length > 1) {
      $('#g-item-manager').addClass(i18next.resolvedLanguage);
    }

    //store it for switching
    $('#g-item-manager').data('lang', i18next.resolvedLanguage);

    this.localise('#g-item-manager');
  }

  language() {
    return i18next.resolvedLanguage;
  }

  numberFormat(number, opts={}) {
    return (new Intl.NumberFormat(this.language(), opts).format(number));
  }
}
export {i18n};